module.exports = __webpack_public_path__ + "static/media/Upload.4ff04f96.svg";